import styled from 'styled-components';

export const SearchPageContainer = styled.div`
  position: relative;
`;
